import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import VConsole from 'vconsole';
import Button from '../../components/Button';
import Icon, { Icons } from '../../components/Icon/Icon';
import AppConfig from '../../config';
import useBackButton from '../../hooks/useBackButton';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import './ErrorPage.scss';

const { routes, isEnableDevTools } = AppConfig;

const iconWidth = 232;
const iconHeight = 182;

const ErrorPage = () => {
	const stateLink = useLocation();
	const navigate = useNavigate();
	const location = useLocation();
	useBackButton(true);

	const defaultError = {
		icon: 'ErrorAll',
		title: t('An error occurred'),
		text: t('Oops! Something went wrong. Please try again.'),
		btnFunction: () => navigate(-1),
		btnText: t('Refresh'),
	};

	const contactSupport = () => {
		navigate(routes.error, {
			state: {
				name: 'ErrorProcessed',
			},
		});
	};

	const errors = {
		ErrorAuthorization: {
			icon: 'ErrorAuthorization',
			title: t('Authorization failed'),
			text: t('Oops! Something went wrong. Please try again.'),
			btnFunction: () => alert('havent func'),
			btnText: t('Contact support'),
		},
		ErrorFirstLogin: {
			icon: 'ErrorAuthorization',
			title: t('First login attempt is failed'),
			text: t('Oops! Something went wrong. Please try again.'),
			btnFunction: () => navigate(-1),
			btnText: t('Back'),
		},
		ErrorBlocked: {
			icon: 'ErrorBlocked',
			title: t('Your account has been blocked'),
			text: t('Please contact support for assistance'),
			btnFunction: contactSupport,
			btnText: t('Contact support'),
		},
		ErrorProcessed: {
			icon: 'ErrorProcessed',
			title: t('Your request is being processed'),
			text: t('Your unblock request has been sent to support'),
			btnFunction: () => navigate(-2),
			btnText: t('Back'),
		},
		ErrorQr: {
			icon: 'ErrorQr',
			title: t('QR code reading error'),
			text: t('Oops! Something went wrong. Please try again.'),
			btnFunction: () => navigate(-1),
			btnText: t('Try again'),
		},
		InvalidTelegramAccountError: {
			icon: 'ErrorAll',
			title: t('An error occurred'),
			text: t("Error! You're trying to login to Mobile account from wrong Telegram"),
			btnFunction: () => navigate(-1),
			btnText: t('Refresh'),
		},
	};

	const copyError = () => {
		navigator.clipboard.writeText(location?.state?.error);
		HelperService.showNotification({ type: 'success', body: t('Copied') });
	};

	const error = errors[stateLink?.state?.name] || defaultError;

	useEffect(() => {
		if (isEnableDevTools) new VConsole();
	});

	return (
		<div className='ErrorPage'>
			<div className='ErrorPage__content'>
				<Icon type={Icons[error.icon]} width={iconWidth} height={iconHeight} />

				<div className='ErrorPage__text-block'>
					<div className='ErrorPage__error-title'>{error.title}</div>
					<div className='ErrorPage__error-text'>{location?.state?.error || error.text}</div>
				</div>
			</div>

			{location?.state?.error ? (
				<Button onClick={copyError}>{t('Copy error code')}</Button>
			) : (
				<Button onClick={() => error.btnFunction()}>{error.btnText}</Button>
			)}
		</div>
	);
};

export default ErrorPage;
